import React from 'react'
import {Link} from 'react-router-dom'
import '../../css/elements/logo.css'

const Logo = () => (
  <Link
    to="/"
    className="logo d-flex justify-content-start align-items-center flex-nowrap">
    <img src="/assets/images/produb_logo_small.png"  alt="" />
  </Link>
)

export default Logo
